import { render } from "./BonusPage.vue?vue&type=template&id=ad7abb5e&scoped=true"
import script from "./BonusPage.vue?vue&type=script&lang=js"
export * from "./BonusPage.vue?vue&type=script&lang=js"

import "./BonusPage.vue?vue&type=style&index=0&id=ad7abb5e&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7abb5e"]])

export default __exports__